export const ACCOUNT_BUSINESS_INDUSTRIES = Object.freeze({
  AUTOMOTIVE: 'Automotive',
  AGRICULTURE: 'Agriculture',
  BANKING: 'Banking',
  CONSTRUCTION: 'Construction',
  CONSUMER: 'Consumer',
  EDUCATION: 'Education',
  ENGINEERING: 'Engineering',
  ENERGY: 'Energy',
  OIL_AND_GAS: 'Oil & Gas',
  FAST_MOVING_CONSUMER_GOODS: 'Fast moving consumer goods',
  FINANCIAL: 'Financial',
  FINTECH: 'Fintech',
  FOOD_AND_BEVERAGE: 'Food & Beverage',
  GOVERNMENT: 'Government',
  HEALTHCARE: 'Healthcare',
  HOSPITALITY: 'Hospitality',
  INSURANCE: 'Insurance',
  LEGAL: 'Legal',
  MANUFACTURING: 'Manufacturing',
  MEDIA: 'Media',
  ONLINE: 'Online',
  PROFESSIONAL_SERVICES: 'Professional Services',
  RAW_MATERIALS: 'Raw materials',
  REAL_ESTATE: 'Real Estate',
  RELIGION: 'Religion',
  RETAIL: 'Retail',
  JEWELRY: 'Jewelry',
  TECHNOLOGY: 'Technology',
  TELECOMMUNICATIONS: 'Telecommunication',
  TRANSPORTATION: 'Transportation',
  TRAVEL: 'Travel',
  ELECTRONICS: 'Electronics',
  NOT_FOR_PROFIT: 'Not for profit',
});

/**
 * This is a little hacky, but it's currently only used to set the default
 * in an admin area. This maps our industries in the database to the industries found above,
 * which were defined by Twilio. Adding a new industry to the database doesn't require
 * and update here, as it'll just be `undefined` and no default will be set
 */
export const TEAM_ENGINE_INDUSTRY_TO_TWILIO_INDUSTRY = Object.freeze({
  10: 'AUTOMOTIVE',

  // Beverage Distribution
  13: 'TRANSPORTATION',

  // Cleaning
  3: 'HOSPITALITY',

  // Construction/Roofing, etc.
  1: 'CONSTRUCTION',

  // Customer Service
  9: 'CONSUMER',

  // Driving (Truck, Railroad, Bus, etc.)
  2: 'TRANSPORTATION',

  // Facilities/Maintenance
  8: 'HOSPITALITY',

  // Food
  14: 'FOOD_AND_BEVERAGE',

  12: 'HEALTHCARE',

  // Hospitality/Restaurant
  11: 'HOSPITALITY',

  // Landscaping
  15: 'AGRICULTURE',

  5: 'MANUFACTURING',

  // Moving
  16: 'TRANSPORTATION',

  // Office
  6: null,

  // Other
  0: null,

  4: 'RETAIL',

  // Sales
  7: null,
});
